/**
 * Created by dev on 2/22/16.
 */
"use strict";

var AlertView = require('./index.js');
var _ = require('underscore');
var $ = require('dibs-jquery-shim');

/**
 * Adds alert message functionality to your view
 *
 *
 * @example
 * _.extend(MyView.prototype, viewMessage)
 * var test = new MyView();
 * test.message('Hello!, this message brought to you by message mixin', 'info', '.message-wrapper');
 *
 * @mixin messageMixin
 */
module.exports = /* @lends messageMixin */{
    /**
     * Display a message on the form view.
     * @param {string} text The text to display
     * @param {string} [type] The type of message (error, info, or success)
     * @param {string|HTMLElement|$} [where]
     *      Where to put the message (a selector or an element). If not provided
     *      it will look for a 'messageLocation' property on the view to use instead
     * @param {object} config The alertView config
     * @memberOf messageMixin
     * @return Backbone.View
     */
    message: function (options) {
        var key;
        var $where;
        if ("string" === typeof options) {
            options = {};
            options.text = arguments[0];
            options.type = arguments[1];
            options.where = arguments[2];
            options.config = arguments[3];
        }
        options = $.extend(true, {
            text: ((options.type === 'error') ? 'The server encountered an error.' : 'Your item is being saved...'),
            type: 'info',
            where: this.messageLocation,
            config: {
                animate: true,
                close: true
            }
        }, options);
        if (!options.where) {
            return this;
        }

        key = options.where;

        if (!_.isString(options.where)) {
            if (!this._messageLocations) {
                this._messageLocations = [];
            }
            key = _.indexOf(this._messageLocations, options.where);
            if (key === -1) {
                this._messageLocations[(key = this._messageLocations.length)] = options.where;
            }
        }

        if (!this._messages) {
            this._messages = {};
        }

        this._messages[key] = this._messages[key] || new AlertView($.extend(true,
                {alert: options.text},
                _.pick(options, 'type', 'config', 'actions')
            ));

        $where = this.$(options.where);

        if (!$where.find('.alert').length) {
            $where.html(this._messages[key].$el.stop());
            _.extend(this._messages[key].alert, {
                message: options.text,
                type: options.type
            });
            this._messages[key].render()
                .open()
                .delegateEvents();
        } else {
            this._messages[key].resetMessage(options.text, options.type);
        }

        return this;
    },
    /**
     * Close a message
     * @param {string|HTMLElement|$} where
     * @memberOf messageMixin
     * @returns {Backbone.View}
     */
    closeMessage: function (where) {
        var message;
        where = where || this.messageLocation;

        if (!this._messages) {
            return this;
        }

        message = this.getMessage(where);

        if (!message) {
            return this;
        }

        // don't execute close if element is already hidden
        if (message.$el.css('display') !== 'none') {
            message.close();
        }
        return this;
    },
    /**
     * Gets the message location view.
     * @param {string|HTMLElement|$} where
     * @returns {AlertView|false} View where message should be
     * @memberOf messageMixin
     */
    getMessage: function (where) {
        if (_.isString(where)) {
            return this._messages[where];
        }
        if (this._messageLocations) {
            return this._messages[_.indexOf(this._messageLocations, where)];
        }
        return false;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-alert-view/messageMixin.js
// module id = 694
// module chunks = 4 6 7 8 9 13 17